module.exports = __webpack_public_path__ + "img/fontsForEngravings.9fb1e14.jpg";